/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Moreaboutroles3Inputs */

const en_usermanagement_permissions_moreaboutroles3 = /** @type {(inputs: Usermanagement_Permissions_Moreaboutroles3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more about User Roles`)
};

/**
* | output |
* | --- |
* | "Learn more about User Roles" |
*
* @param {Usermanagement_Permissions_Moreaboutroles3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_moreaboutroles3 = /** @type {((inputs?: Usermanagement_Permissions_Moreaboutroles3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Moreaboutroles3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_moreaboutroles3(inputs)
});
export { usermanagement_permissions_moreaboutroles3 as "userManagement_permissions_moreAboutRoles" }